import axios from 'axios';
import * as api from '@eventManager/api';
import { getNextPageProducts } from '@eventManager/processes';
import { EventOccurrence } from '@groupForecaster/models';
import * as MutationTypes from '../mutationTypes';

export const eventOccurrenceCalendarListRequest = async ({
  commit,
  getters: { eventOccurrenceCalendarList }
}) => {
  try {
    if (eventOccurrenceCalendarList.length === 0) {
      const { CancelToken } = axios;
      const source = CancelToken.source();
      const { token } = source;
      commit(MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_TOKEN, source);
      const response = await api.eventOccurrenceCalendarListRequest(token, {});
      if (response) {
        const { count, results } = response.data;
        const eventOccurrenceList = EventOccurrence.toInstanceList(results);
        commit(MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_UPDATE, { eventOccurrenceList, count });
        if (response.data.next) {
          await getNextPageProducts(commit, response.data.next, token);
        }
      }
      commit(MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_SUCCESS);
    }
  } catch (err) {
    commit(MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_ERROR);
    throw err;
  }
};

export const resetEventOccurrenceCalendarList = ({ commit }) => {
  commit(MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_RESET);
};
